<template>
	<div id="ask" class="col-lg-8">
		<div v-if="isSend">
			<div class="tile">
				<div>
					<div>
						<h4>Уважаемый(ая) {{ fullname }}</h4>
					</div>
					<div>
						Обращению заявителя <b>{{ fio }}</b>
						присвоен исходящий номер <b>{{ uid }}</b>.
					</div>
					<div>
						Дальнейшую обработку и рассмотрение обращения следует продолжить в МСЭДе.
					</div>
				</div>
				<div>
					<button @click="isSend = false" class="btn blue" type="submit" id="submit_ask" name="submit_ask">
						Отправить новое
					</button>
				</div>
			</div>
		</div>
		<template v-if="!isSend">
			<form v-if="isAuth" enctype="multipart/form-data">
				<div class="tile">
					<div class="form-group">
						<div class="">
							<div class="text required">
								<label class="text required" for="source">
									Откуда поступило
								</label>
							</div>
							<div v-show="errors.find(x => x === 'source')" class="formErrors">
								<strong>
									Не выбран способ доставки
								</strong>
							</div>
							<div class="input-field">
								<select id="source" v-model="source" required>
									<option disabled value="">Выбрать из списка</option>
									<option v-for="item in sources" :key="item.id" :value="item.id">
										{{ item.name }}
									</option>
								</select>
							</div>
						</div>
					</div>
				</div>

				<div class="tile">
					<div class="form-group">
						<div class="">
							<div class="text required">
								<label class="text required" for="local_government">
									Орган местного самоуправления, на территории которого проживает заявитель
								</label>
							</div>
							<div v-show="errors.find(x => x === 'local_government')" class="formErrors">
								<strong>
									Не выбран орган местного самоуправления
								</strong>
							</div>
							<div class="input-field">
								<select v-model="local_government" id="local_government" required>
									<option disabled value="">Выбрать из списка</option>
									<option v-for="item in local_governments" :key="item.id" :value="item.id">
										{{ item.name }}
									</option>
								</select>
							</div>
						</div>
					</div>
				</div>
				<div class="tile">
					<div class="form-group">
						<div class="text required">
							<label class="text required" for="zone">
								Выберите адресата
							</label>
						</div>
						<div v-show="errors.find(x => x === 'zone')" class="formErrors">
							<strong>
								Не выбран адресат
							</strong>
						</div>
						<div class="input-field">
							<select v-model="zone" id="zone">
								<option disabled value="">Выбрать из списка</option>
								<option v-for="item in zones" :key="item.id" :value="item.id">
									{{ item.name }}
								</option>
							</select>
						</div>
					</div>
					<div class="form-group">
						<div class="text required">
							<label class="text required" for="type">
								Тип обращения
							</label>
						</div>
						<div v-show="errors.find(x => x === 'type')" class="formErrors">
							Не выбран тип обращения
						</div>
						<div class="input-field">
							<select v-model="type" id="type">
								<option disabled value="">Выбрать из списка</option>
								<option v-for="item in types" :key="item.id" :value="item.id">
									{{ item.name }}
								</option>
							</select>
						</div>
					</div>
					<div class="form-group">
						<div class="text required">
							<label class="text required" for="doc_type">
								Тип вида документа
							</label>
						</div>
						<div v-show="errors.find(x => x === 'doc_type')" class="formErrors">
							Не выбран тип вида документа
						</div>
						<div class="input-field">
							<select v-model="doc_type" id="doc_type" required>
								<option disabled value="">
									Выбрать из списка
								</option>
								<option v-for="item in doc_types" :key="item.id" :value="item.id">
									{{ item.name }}
								</option>
							</select>
						</div>
					</div>
					<div class="form-group">
						<div class="text required">
							<label class="text required" for="theme">
								Краткое содержание
							</label>
						</div>
						<div v-show="errors.find(x => x === 'theme')" class="formErrors">
							<strong>
								Отсутствует краткое содержание обращения
							</strong>
						</div>
						<div class="info">
							<span>
								Пожалуйста, кратко обозначьте вопрос.
							</span>
						</div>
						<div class="input-field">
							<input v-model="theme" id="theme" class="text-input" title="Кратко, содержание обращения"
								type="text" required>
						</div>
					</div>
					<div class="form-group">
						<div class="text required">
							<label class="text required" for="topic">
								Текст обращения
							</label>
						</div>
						<div class="formErrors" v-show="errors.find(x => x === 'topic')">
							<strong>
								Отсутствует текст обращения
							</strong>
						</div>
						<div class="input-field">
							<textarea v-model="topic" id="topic" rows="5"></textarea>
						</div>
					</div>
					<div>
						<div class="checkbox">
							<input v-model="mp" id="mp" type="checkbox">
							<label for="mp">
								Коллективное обращение
							</label>
						</div>
						<div class="info2" v-show="mp">
							<span>
								<strong>
									Внимание!
								</strong>
								<br>
								Для отправки коллективного обращения Вы должны приложить файл, содержащий список соавторов
							</span>
						</div>
						<div class="form-group">
							<div class="form__title-file active" @click="addFile" id="files">Прикрепить файлы</div>
							<div v-show="errors.find(x => x === 'files')" class="formErrors">
								<strong>
									Не прикреплены файлы
								</strong>
							</div>
							<div class="form__input-files">
								<div class="form__input-file" v-for="(item, index) in files" :key="index">
									<div class="qwer"></div>
									<input type="text" class="form__input-files-text" disabled :value="item.name">
									<div class="form__btns">
										<input type="file" name="userfile[]" :id="`file` + index"
											@change="(e) => selectFile(e.target.files[0], index)"
											class="form__input-file-elem">
										<label :for="`file` + index" class="form__label-file btn blue">Выбрать</label>
										<div class="btn blue form__btn form__btn-close" @click="() => deleteFile(index)">
										</div>
										<div class="btn blue form__btn form__btn-add" @click="addFile"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="tile">
					<div class="form-group row">
						<div class="text required col-sm-4">
							<div class="text required">
								<label class="text required" for="name">
									Фамилия, имя, отчество в именительном падеже
								</label>
							</div>
						</div>
						<div class="input-group col-sm-8">
							<div class="input-field">
								<input v-model="name" id="name" class="text-input" title="Ваша фамилия" type="text"
									required="" placeholder="Фамилия">
							</div>
							<div class="formErrors" v-show="errors.find(x => x === 'name')">
								Отсутствует фамилия
							</div>
							<div class="input-field">
								<input v-model="firstname" id="firstname" class="text-input" title="Ваше имя" type="text"
									required="" placeholder="Имя">
							</div>
							<div class="formErrors" v-show="errors.find(x => x === 'firstname')">
								Отсутствует имя
							</div>
							<div class="input-field">
								<input v-model="secondname" id="secondname" class="text-input" title="Ваше отчество"
									type="text" placeholder="Отчество">
							</div>
							<div class="checkbox">
								<input v-model="snchk" id="snchk" type="checkbox">
								<label for="snchk">
									Отчество отсутствует
								</label>
							</div>
						</div>
					</div>
					<div class="form-group row">
						<div class="text col-sm-4 required">
							<label class="text required" for="social">
								Социальное положение
							</label>
						</div>
						<div class="formErrors" v-show="errors.find(x => x === 'social')">
							Не выбрано социальное положение
						</div>
						<div class="input-field col-sm-8">
							<ModelSelect ref="social-select" :options="socials" v-model="social"
								placeholder="Выбрать из списка" id="social">
							</ModelSelect>
						</div>
					</div>
					<div class="form-group row">
						<div class="text col-sm-4 required">
							<label class="text required" for="user_type">
								Льготный состав
							</label>
						</div>
						<div class="formErrors" v-show="errors.find(x => x === 'user_type')">
							Не выбран льготный состав
						</div>
						<div class="input-field col-sm-8">
							<ModelSelect ref="user_type-select" :options="user_types" v-model="user_type"
								placeholder="Выбрать из списка" id="user_type">
							</ModelSelect>
						</div>
					</div>
				</div>
				<div class="tile">
					<div class="form-group row">
						<div class="text col-md-8">
							<label class="text required" for="input-77">
								Адрес для направления ответа:
							</label>
						</div>
					</div>
					<div class="optional" id="option-1">
						<div class="form-group row">
							<div class="text col-md-4">
								<label class="text" for="postcode">
									Почтовый индекс
								</label>
							</div>
							<div class="formErrors" v-show="errors.find(x => x === 'postcode')">
								Введите почтовый индекс
							</div>
							<div class="input-field col-md-8">
								<input v-model="postcode" id="postcode" class="text-input" title="Почтовый индекс"
									type="text">
							</div>
						</div>
						<div class="form-group row">
							<div class="text col-md-4">
								<label class="text" for="locality">
									Населенный пункт
								</label>
							</div>
							<div class="formErrors" v-show="errors.find(x => x === 'locality')">
								Введите населённый пункт
							</div>
							<div class="input-field col-md-8">
								<input v-model="locality" id="locality" class="text-input" title="Населенный пункт"
									type="text">
							</div>
						</div>
						<div class="form-group row">
							<div class="text col-md-4">
								<label class="text" for="address">
									Адрес
								</label>
							</div>
							<div class="formErrors" v-show="errors.find(x => x === 'address')">
								Введите адрес
							</div>
							<div class="input-field col-md-8">
								<input v-model="address" id="address" class="text-input" title="Адрес" type="text">
							</div>
						</div>
						<div class="form-group row">
							<div class="text col-md-4">
								<label class="text" for="emailvalue">
									Укажите e-mail
								</label>
							</div>
							<div class="input-field col-md-8">
								<input v-model="emailvalue" id="emailvalue" class="text-input"
									title="Адрес Вашей электронной почты" type="email">
							</div>
						</div>
						<div class="formErrors" v-show="errors.find(x => x === 'wrong-email')">
							Некорректный e-mail
						</div>
						<div class="form-group row">
							<div class="text col-md-4">
								<label class="text" for="telNo">
									Контактный телефон
								</label>
							</div>
							<div class="input-field col-md-8">
								<input v-model="telNo" id="telNo" class="text-input" type="tel">
							</div>
						</div>
					</div>
					<div class="formErrors" v-show="errors.find(x => x === 'all-address')">
						Нет ни почтового, ни электронного адреса для отправки ответа. Введите хотя бы один адрес.
					</div>
				</div>
				<div class="tile">
					<div class="form-group">
						<div class="info2">
							В случае обращения от имени юридического лица, заполните дополнительно:
						</div>
						<div class="form-group row">
							<div class="text">
								<label class="text" for="position">
									Должность
								</label>
							</div>
							<div class="input-field">
								<input v-model="position" id="position" class="text-input" title="Должность" type="text">
							</div>
						</div>
						<div class="form-group row">
							<div class="text">
								<label class="text" for="company">
									Наименование юридического лица:
								</label>
							</div>
							<div class="input-field">
								<input v-model="company" id="company" class="text-input"
									title="Наименование юридического лица" type="text">
							</div>
						</div>
					</div>
				</div>
				<div class="tile">
					<div class="info">
						<strong>
							Внимание!
						</strong>
						<br>
						Повторная отправка обращений существенно замедляет процесс обработки и рассмотрения обращения. Во
						избежание повторной отправки обращений, убедительная просьба перед отправкой проверить правильность
						заполнения всех полей
					</div>
					<div class="formErrors">
						{{ message }}
					</div>
					<button @click="save" class="btn blue" type="submit" id="submit_ask" name="submit_ask"
						:disabled="sending">
						Сохранить
					</button>
				</div>
			</form>
			<div v-else>
				Недостаточно прав для доступа к этой странице
			</div>
		</template>
	</div>
</template>

<script>
import { ModelSelect } from "vue-search-select"
import validateEmail from '@/functions/validateEmail'
import { getData, getDataReg } from '@/api/getData'
import authMixin from '@/mixins/authMixin'
import { postWithToken } from "@/api/saveData"
import { getConfig, getFullName } from '@/auth'

export default {
	components: {
		ModelSelect
	},
	mixins: [
		authMixin
	],
	data() {
		return {
			fullname: getFullName(),
			arr: [],
			errors: [],

			source: '',
			sources: [],

			local_government: '',
			local_governments: [],

			zone: '',
			zones: [],
			type: '',
			types: [],

			doc_type: '',
			doc_types: [],

			theme: '',

			topic: '',

			mp: false,
			files: [],

			fio: '',
			name: '',
			firstname: '',
			secondname: '',
			snchk: false,

			social: '',
			socials: [],

			user_type: '',
			user_types: [],

			answer_type: 'email',
			answer_types: [{ value: 'email', label: 'Электронный адрес' },],

			postcode: '614000',
			locality: 'г. Пермь',
			address: '',

			emailvalue: '',

			telNo: '+7',

			position: '',
			company: '',

			consent: false,
			haveRead: false,

			captcha: '',

			isCheck: false,

			isSend: false,

			uid: -1,
			success: null,

			message: '',

			sending: false,
		}
	},
	created() {
		getData().then(x => {
			let { local_governments, zones, types, socials, user_types } = x

			this.local_governments = local_governments
			this.local_government = local_governments?.[0]?.id ?? ''
			this.zones = zones
			this.types = types
			this.type = types?.[0]?.id ?? ''
			this.socials = socials.map(x => ({ ...x, value: x.id, text: x.name }))
			this.social = socials?.[0]?.id ?? ''
			this.user_types = user_types.map(x => ({ ...x, value: x.id, text: x.name }))
			this.user_type = user_types?.[0]?.id ?? ''

			getDataReg().then(x => {
				let { sources, doc_types } = x

				this.sources = sources
				this.doc_types = doc_types
				this.doc_type = doc_types?.[0]?.id ?? ''
			})

		})
	},
	methods: {
		save: function (e) {
			e.preventDefault();

			if (this.sending) return;

			this.errors = []
			let top = null;
			this.isCheck = true

			let required = [
				{ field: 'source', value: '' },
				{ field: 'local_government', value: '' },
				{ field: 'zone', value: '' },
				{ field: 'type', value: '' },
				{ field: 'doc_type', value: '' },
				{ field: 'theme', value: '' },
				{ field: 'topic', value: '' },
				{ field: 'name', value: '' },
				{ field: 'social', value: '' },
				{ field: 'user_type', value: '' },
			]

			required.forEach(x => {
				if (!this[x.field] || this[x.field] === x.value) {
					this.errors.push(x.field)
					if (top === null) top = document.getElementById(x.id ?? x.field)
				}
			})

			if (this.emailvalue === '' || this.postcode === '' || this.locality === '' || this.address === '') {
				if (this.emailvalue === '' && this.postcode === '' && this.locality === '' && this.address === '') {
					this.errors.push('all-address')
					if (top === null) top = document.getElementById('emailvalue')
				} else if (this.emailvalue === '') {
					if (top === null) top = document.getElementById('postcode')

					if (this.postcode === '') this.errors.push('postcode')
					if (this.locality === '') this.errors.push('locality')
					if (this.address === '') this.errors.push('address')
				}
			}

			if (this.emailvalue !== '' && validateEmail(this.emailvalue) === null) {
				if (top === null) top = document.getElementById('emailvalue')
				this.errors.push('wrong-email')
			}

			let filesLength = this.files.filter(x => x.name).length
			if (filesLength === 0) {
				top = document.getElementById('files')
				this.errors.push('files')
			}

			if (this.errors.length > 0) {
				top?.scrollIntoView({ block: 'center' })
			} else {
				let source = this.source
				let local_government = this.local_government
				let zone = this.zone
				let doc_type = this.doc_type
				let type = this.type
				let theme = this.theme
				let topic = this.topic
				let mp = this.mp
				let files = this.files
				let name = this.name
				let firstname = this.firstname
				let secondname = this.secondname
				//let snchk = this.snchk
				let social = this.social
				let user_type = this.user_type
				//let answer_type = this.answer_type
				let postcode = this.postcode
				let locality = this.locality
				let address = this.address
				let emailvalue = this.emailvalue
				let telNo = this.telNo
				let position = this.position
				let company = this.company

				let formData = new FormData();
				for (let i = 0; i < files.length; i++) {
					if (files[i].name) formData.append("files[]", files[i]);
				}
				formData.append("last_name", name);
				formData.append("first_name", firstname);
				formData.append("middle_name", secondname);
				formData.append("theme", theme);
				formData.append("topic", topic);
				formData.append("is_collective", mp ? '1' : '0');
				formData.append("email", emailvalue);
				formData.append("phone_number", telNo);
				formData.append("position", position);
				formData.append("company", company);
				formData.append("zone_id", zone);
				formData.append("appeal_type_id", type);
				formData.append("local_government_id", local_government);
				formData.append("social_group_id", social);
				formData.append("preferential_group_id", user_type);

				formData.append("zip_code", postcode);
				formData.append("city", locality);
				formData.append("address", address);
				formData.append("delivery_type_id", source);
				formData.append("document_type_id", doc_type);

				this.sending = true

				postWithToken(getConfig().appealsSaveRegistrarUrl, formData)
					.then(x => {
						this.success = x.success
						this.uid = x?.data?.uid ?? '';
						if (this.uid !== '') {
							this.isSend = true
							this.fio = `${x.data.last_name ?? ''} ${x.data.first_name ?? ''} ${x.data.middle_name ?? ''}`;

							this.source = ''
							this.local_government = this.local_governments?.[0]?.id ?? ''
							this.zone = ''
							this.doc_type = this.doc_types?.[0]?.id ?? ''
							this.type = this.types?.[0]?.id ?? ''
							this.theme = ''
							this.topic = ''
							this.mp = ''
							this.name = ''
							this.firstname = ''
							this.secondname = ''
							this.snchk = ''
							this.social = this.socials?.[0]?.id ?? ''
							this.user_type = this.user_types?.[0]?.id ?? ''
							this.answer_type = ''
							this.postcode = '614000'
							this.locality = 'г. Пермь'
							this.address = ''
							this.emailvalue = ''
							this.telNo = ''
							this.position = ''
							this.company = ''
							this.files = []

							document.body.scrollTop = 0;
							document.documentElement.scrollTop = 0;
							this.message = ''
						} else {
							this.message = x.message
						}
					})
					.finally(() => this.sending = false)
			}
		},

		addFile: function () {
			this.files.push({})
		},
		selectFile: function (file, index) {
			this.files[index] = file
		},
		deleteFile: function (index) {
			this.files.splice(index, 1)
		},
	}
}

</script>